// extracted by mini-css-extract-plugin
module.exports = {"chat-banner":"ChatBanner_chat-banner__8S3Z3","subtitle":"ChatBanner_subtitle__s1ttp"};